import React from 'react';

const ExperienceContext = React.createContext();

export default ExperienceContext;
